import Profilephoto from "./images/pass photo.jpg";
function Header() {
  return (
    <div class="container">
      <div class="section">
        <div class="profile-image">
          <img src={Profilephoto} alt="Profile" />
          <p>
            <span class="h3">My Portfolio website</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Header;
